import { clubShowsHourlyCourtPlans, clubWantsCardPayments } from "./clubCapabilities";

export const CART_VENDOR_REQUIRED =
  "You chose to take card payments. Complete Financial Vendor before players can check out.";

export const CHECKOUT_VENDOR_REQUIRED =
  "Complete Financial Vendor before taking cards.";

export const HOURLY_COURT_VENDOR_REQUIRED =
  "To get paid for hourly court time, complete Financial Vendor. Players pay the club through Stripe there. That is not your SportMingle plan.";

export const FINANCIAL_VENDOR_PATH = "/finances";

export function clubNeedsConnectToGetPaid(club) {
  return clubShowsHourlyCourtPlans(club) && clubWantsCardPayments(club);
}

export function isFinancialVendorVerified(response) {
  return response?.Status === 200 && response?.Data === true;
}

export function checkoutVendorErrorMessage(error) {
  const data = error?.response?.data;
  const text = [data?.Message, data?.detail, data?.message, data?.Data]
    .find((value) => typeof value === "string" && value.trim());
  if (!text) {
    return "";
  }
  if (error?.response?.status === 400 && /financial vendor/i.test(text)) {
    return CHECKOUT_VENDOR_REQUIRED;
  }
  return "";
}
